module.exports = __webpack_public_path__ + "static/media/wpp_new_message_sound.ffa42c67.mp3";